import React, { Fragment } from 'react'
import Footer from '../../component/Other/Footer'
import Navbar from '../../component/Other/Navbar'
import Contact from '../../component/Section/Contact'
import ServiceSec from '../../component/Section/Service'
import Head from '../../component/Section/Head'
import Number from '../../component/Section/Number'
import Step from '../../component/Section/Step'

const Service = () => {
    const service = [
        {
            img: "./../images/ds (1).png",
            title: "Panel Çit",
            desc: "Panel Çit Nedir? Panel çit sınır belirleyici özelliğinin yanı sıra çevre güvenliğini de sağlayan ve aynı zamanda her mekana dekoratif ve estetik görsellik kazandıran bir tel örgü sistemidir. Panel Çit Özellikleri Panel çit, tel örgülü yapısından dolayı simetrik, şık ve dekoratif bir görünüme sahip olan panel çitlerin tel kaplamaları, statik boyanın galvaniz üzerine uygulanması ile yapılmaktadır.",
            url:"1",
        },
        {
            img: "./../images/kanatlı kapı (37).jpg",
            title: "Kapı Sistemleri",
            desc: "Panel çit kapı, panel çit uygulamaları ile oluşturulan alana giriş çıkış sağlamak amacıyla yerleştirilen yada güvenli alanlar için güvenlik noktası olarak belirlenen kapılardır. Panel çit kapılar standart ya da ihtiyacınıza uygun ölçülerde hazırlanmakta olup, belirlenmiş olan dış yada iç mekan alana kolayca uygulanabilmektedir.",
            url:"2",
        },
        
        {
            img: "./../images/telçit (3).png",
            title: "Tel Çit Sistemleri",
            desc: "Tel çit sistemleri sınırları belli olan bir bölge temel alınarak, o sınırlar içerisinde bulunan başka bir alanla çakışma yaşama gibi bir durumun engellenmek istenmektedir. Bu amaçla bir bölge ile sınır belirlemek ya da o bölgeyi korumak, bölgenin kendisine ait bir araziye sahip olduğunu gösterebilmek için kullanılmakta olan çevreleme sistemlerine tel çit sistemleri adı verilmektedir.",
            url:"3",
        },
        {
            img: "./../images/ds (4).png",
            title: "Pano Çit",
            desc: "Genellikle kare ve dikdörtgen şeklinde kullanılan pano çit, isteğe göre değişik şekil ve boyutlarda yapılmaktadır. Pano çit, alan düzenlemelerinin yapılmasından sonra zemin ya da duvar üzerine eşit aralıklarla, önceden hazırlanan köşebent çerçeve içerisine çit hasırlı veya örgü telli panolar monte edilerek yapılmaktadır.",
            url:"4",
        },
        {
            img: "./../images/ds (5).png",
            title: "Dekoraçim",
            desc: "Çim çit Dekoraçim, dekoratif, dayanıklı ve sağlam yapısı ile günümüzde oldukça sık tercih edilen bir çim çit türüdür. Çim ve çit’in birleşiminden meydana gelen ürün dekoraçim adı ile bilinmektedir.",
            url:"5",
        },
        {
            img: "./../images/zemin.webp",
            title: "Zemin Kaplamaları",
            desc: "Zemin kaplama malzemelerinden biri olan, Landspace Peyzaj Halıları; estetik görüntü olarak ve pratik bir kullanım açısından oldukça sık tercih edilmektedir. İşyeri, restoran, kafeterya açık mekan doğal görünümlü olan yerlerde, profesyonel halı saha ve lig sahaları için oldukça sık bir biçimde tercih edilmektedir.",
            url:"6",
        },
        {
            img: "./../images/ds (7).png",
            title: "Spor Sahaları",
            desc: "Eymen Tel Çit çatısı altında bütün spor sahaları yapımı ürünleri ve çeşitleri mevcuttur. Spor sahası yapımında uzmanlaşmış kadrosuyla Demirhan, açık ve kapalı spor sahaları kısa bir sürede anahtar teslim olarak inşa etmektedir.",
            url:"7",
        },
        {
            img: "./../images/ds (8).png",
            title: "Spor Ekipmanları",
            desc: "Tel çit sistemleri ve spor sahaları sektöründe, malzemenin üretiminden uygulamaya kadar hizmet veren Eymen Tel Çit, spor ekipmanları olarak, Çocuk Oyun Grupları, Futbol kalesi, Basketbol potası, Voleybol direği, Tenis direği, Tribün koltuğu, Scoreboard ve Projektör çeşitleriyle üretimden uygulamaya kadar hizmet sunmaktadır.",
            url:"8",
        
        },
    ]
    return (
        <Fragment>
            <div className="overflow-hidden">
                <div className="position-relative">
                    <img src="./../images/Bg.png" className="images__wrap-head" alt="" />
                    <div className="wrapper__bg-head"></div>
                    <Navbar />
                    <Head default="" current="HER TEL İŞTE BIR ADIM ÖTESI!" title={"Servislerimiz"} />
                </div>

                <ServiceSec service={service} type="service" />

                <Number />

                <Step />

                <Contact />

                <Footer />
            </div >
        </Fragment>
    )
}

export default Service